import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-basic-list',
	templateUrl: './basic-list.component.html',
	styleUrls: ['./basic-list.component.scss']
})
export class BasicListComponent {
	@Input() options: any[] = [];
	@Input() listWidth = '';
	@Input() displayField = 'descripcion';
}
